/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { SalientPoints } from '@thd-olt-component-react/salient-points';
import { extend } from '@thd-nucleus/data-sources';

const { node, element, arrayOf } = PropTypes;

export const AdditionalDetails = ({ itemId, children = null }) => {

  return (
    <div className="sui-pt-4 lg:sui-pl-8" data-testid="additional-details">
      {children || (<SalientPoints itemId={itemId} />)}
    </div>
  );
};

AdditionalDetails.displayName = 'AdditionalDetails';

AdditionalDetails.dataModel = extend(SalientPoints);

AdditionalDetails.propTypes = {
  itemId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([node, element, arrayOf(element)])
};


